<template>
  <div></div>
</template>

<script>
import config from "../assets/script/config/index.js";
import { mapMutations, mapState } from "vuex";
import Cookies from "js-cookie";
export default {
  name: "Login",
  computed: {
    ...mapState("user", ["userToken"])
  },
  methods: {
    ...mapMutations("user", ["setUserInfo", "setUserLevel"]),
    getUserInfo() {
      let user = JSON.parse(Cookies.get("5ceinfo") || "{}") || {};
      // //--------------------------------------------------------------
      // user = {
      //   token:
      //     "987B18A18B0FD800907EBD92D8828CF21C63864AD483829472D64D6DBD519ADE806B831F9553B965",
      //   avatar:
      //     "http://thirdwx.qlogo.cn/mmopen/N09aUC2yOElAUltjhcsU7ib6DXOwicOhssEv56aFyVF7wHfW5fXUAt52cBe49Z5uZKSIHeCUYo917UebrIZ1sRFMMO16OxjSIT/132",
      //   level: 100
      // };
      // let exp = new Date();
      // exp.setTime(exp.getTime() + 99999 * 24 * 60 * 60 * 1000);
      // Cookies.set("5ceinfo", JSON.stringify(user), { expires: exp });
      // //--------------------------------------------------------------

      if (Object.keys(user).length > 0) {
        this.setUserInfo(user.token);
        this.setUserLevel(user.level);
      }
    }
  },
  mounted() {
    this.getUserInfo();
    if (this.userToken !== "") {
      this.$router.go(-1);
    } else {
      window.location.href =
        config.loginUrl + "&r=" + config.jumpAiUrl + "&btn=goBench";
    }
  }
};
</script>

<style scoped></style>
